// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.activityCard {
  display: flex;
  /* justify-content: space-between; */
  /* max-width: 20rem; */
  background: var(--clr-secondary);
  /* padding: 2em; */
  padding: 1.25em 1em;
  /* gap: 2rem; */
  gap: 1rem;
  min-height: 5rem;
  align-items: center;
}

.activityCard__btn,
.activityCard__icon {
  flex: 1 1 25%;
}

.activityCard__btn .cross-mark {
  /* margin-left: -0.75rem; */
  margin-left: -0.15rem;
  margin-bottom: -0.5rem;
  width: -moz-fit-content;
  width: fit-content;
}

.activityCard__btn .cross-mark::before,
.activityCard__btn .cross-mark::after {
  background: #fff;
}

.activityaCard__text {
  font-size: 0.85rem;
  /* max-width: 9rem; */
  flex: 1 1 50%;
  line-height: 1.8;
  color: var(--clr-gray800);
}

.activityaCard__text h3 {
  color: var(--clr-primary);
  font-weight: bolder;
  cursor: pointer;
  line-height: 1.5;
}

.activityCard__icon {
  width: 100%;
  cursor: pointer;
  max-width: 2.5rem;
  display: block;
}

.activityCard__btn {
  display: grid;
  place-items: center;
  width: 100%;
  max-width: 2.5rem;
  height: 2.5rem;
  padding: 0;
}

.activityCard__btn svg {
  display: block;
  width: 2rem;
}

.activityCard__btn.selected {
  background: var(--clr-success);
  border: 1px solid var(--clr-success-dark);
  color: var(--clr-success-dark);
}

.activityCard__btn.selected .tick-mark {
  margin-left: -0.75rem;
}

.activityCard__btn.selected .tick-mark::before,
.activityCard__btn.selected .tick-mark::after {
  background: var(--clr-success-dark);
}

.activitiesCard__btnNext {
  display: flex;
  position: absolute;
  border-radius: 1em;
  top: -4.5rem;
  background: transparent;
  color: var(--clr-primary);
  border: 0.1rem solid var(--clr-gray400);
  right: 1rem;
  background: var(--clr-main-bg);
}

.activitiesCard__btnNext svg {
  width: 1rem;
  margin-left: 0.5rem;
}

.filterBar__counter {
  display: flex;
  width: 100%;
  max-width: 7rem;
  gap: 0.5rem;
  margin: 0 auto;
  justify-content: space-between;
  align-items: center;
}

.filterBar__counter .btn-add,
.filterBar__counter .btn-minus {
  height: 1rem;
}

.filterBar__counter span {
  font-weight: bold;
}

.activityCard__textPrice span {
  font-size: 1.15rem;
  color: var(--clr-primary);
  font-weight: bold;
}

.activityCard__textPrice {
  font-size: 0.85rem;
  line-height: 1.5;
  margin-top: 0.5rem;
  color: var(--clr-gray500);
}

.activityCard__textPrice small {
  color: var(--clr-primary);
}

@media (min-width: 375px) {
  .homeActivities__container {
    grid-template-columns: repeat(auto-fit, minmax(25rem, 1fr));
  }

  .activityCard {
    /* max-width: 20rem; */
    padding: 1.5em 1.25em;
    gap: 1rem;
  }

  .activityCard__icon {
    width: 100%;
    max-width: 3rem;
    display: block;
  }
}
`, "",{"version":3,"sources":["webpack://./src/components/ActivitiesComponent/ActivityCard/ActivityCard.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,oCAAoC;EACpC,sBAAsB;EACtB,gCAAgC;EAChC,kBAAkB;EAClB,mBAAmB;EACnB,eAAe;EACf,SAAS;EACT,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;;EAEE,aAAa;AACf;;AAEA;EACE,2BAA2B;EAC3B,qBAAqB;EACrB,sBAAsB;EACtB,uBAAkB;EAAlB,kBAAkB;AACpB;;AAEA;;EAEE,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,qBAAqB;EACrB,aAAa;EACb,gBAAgB;EAChB,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;EACzB,mBAAmB;EACnB,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,eAAe;EACf,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,WAAW;EACX,iBAAiB;EACjB,cAAc;EACd,UAAU;AACZ;;AAEA;EACE,cAAc;EACd,WAAW;AACb;;AAEA;EACE,8BAA8B;EAC9B,yCAAyC;EACzC,8BAA8B;AAChC;;AAEA;EACE,qBAAqB;AACvB;;AAEA;;EAEE,mCAAmC;AACrC;;AAEA;EACE,aAAa;EACb,kBAAkB;EAClB,kBAAkB;EAClB,YAAY;EACZ,uBAAuB;EACvB,yBAAyB;EACzB,uCAAuC;EACvC,WAAW;EACX,8BAA8B;AAChC;;AAEA;EACE,WAAW;EACX,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,WAAW;EACX,eAAe;EACf,WAAW;EACX,cAAc;EACd,8BAA8B;EAC9B,mBAAmB;AACrB;;AAEA;;EAEE,YAAY;AACd;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;EAClB,yBAAyB;EACzB,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,kBAAkB;EAClB,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE;IACE,2DAA2D;EAC7D;;EAEA;IACE,sBAAsB;IACtB,qBAAqB;IACrB,SAAS;EACX;;EAEA;IACE,WAAW;IACX,eAAe;IACf,cAAc;EAChB;AACF","sourcesContent":[".activityCard {\n  display: flex;\n  /* justify-content: space-between; */\n  /* max-width: 20rem; */\n  background: var(--clr-secondary);\n  /* padding: 2em; */\n  padding: 1.25em 1em;\n  /* gap: 2rem; */\n  gap: 1rem;\n  min-height: 5rem;\n  align-items: center;\n}\n\n.activityCard__btn,\n.activityCard__icon {\n  flex: 1 1 25%;\n}\n\n.activityCard__btn .cross-mark {\n  /* margin-left: -0.75rem; */\n  margin-left: -0.15rem;\n  margin-bottom: -0.5rem;\n  width: fit-content;\n}\n\n.activityCard__btn .cross-mark::before,\n.activityCard__btn .cross-mark::after {\n  background: #fff;\n}\n\n.activityaCard__text {\n  font-size: 0.85rem;\n  /* max-width: 9rem; */\n  flex: 1 1 50%;\n  line-height: 1.8;\n  color: var(--clr-gray800);\n}\n\n.activityaCard__text h3 {\n  color: var(--clr-primary);\n  font-weight: bolder;\n  cursor: pointer;\n  line-height: 1.5;\n}\n\n.activityCard__icon {\n  width: 100%;\n  cursor: pointer;\n  max-width: 2.5rem;\n  display: block;\n}\n\n.activityCard__btn {\n  display: grid;\n  place-items: center;\n  width: 100%;\n  max-width: 2.5rem;\n  height: 2.5rem;\n  padding: 0;\n}\n\n.activityCard__btn svg {\n  display: block;\n  width: 2rem;\n}\n\n.activityCard__btn.selected {\n  background: var(--clr-success);\n  border: 1px solid var(--clr-success-dark);\n  color: var(--clr-success-dark);\n}\n\n.activityCard__btn.selected .tick-mark {\n  margin-left: -0.75rem;\n}\n\n.activityCard__btn.selected .tick-mark::before,\n.activityCard__btn.selected .tick-mark::after {\n  background: var(--clr-success-dark);\n}\n\n.activitiesCard__btnNext {\n  display: flex;\n  position: absolute;\n  border-radius: 1em;\n  top: -4.5rem;\n  background: transparent;\n  color: var(--clr-primary);\n  border: 0.1rem solid var(--clr-gray400);\n  right: 1rem;\n  background: var(--clr-main-bg);\n}\n\n.activitiesCard__btnNext svg {\n  width: 1rem;\n  margin-left: 0.5rem;\n}\n\n.filterBar__counter {\n  display: flex;\n  width: 100%;\n  max-width: 7rem;\n  gap: 0.5rem;\n  margin: 0 auto;\n  justify-content: space-between;\n  align-items: center;\n}\n\n.filterBar__counter .btn-add,\n.filterBar__counter .btn-minus {\n  height: 1rem;\n}\n\n.filterBar__counter span {\n  font-weight: bold;\n}\n\n.activityCard__textPrice span {\n  font-size: 1.15rem;\n  color: var(--clr-primary);\n  font-weight: bold;\n}\n\n.activityCard__textPrice {\n  font-size: 0.85rem;\n  line-height: 1.5;\n  margin-top: 0.5rem;\n  color: var(--clr-gray500);\n}\n\n.activityCard__textPrice small {\n  color: var(--clr-primary);\n}\n\n@media (min-width: 375px) {\n  .homeActivities__container {\n    grid-template-columns: repeat(auto-fit, minmax(25rem, 1fr));\n  }\n\n  .activityCard {\n    /* max-width: 20rem; */\n    padding: 1.5em 1.25em;\n    gap: 1rem;\n  }\n\n  .activityCard__icon {\n    width: 100%;\n    max-width: 3rem;\n    display: block;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
